export const currentWebinar = {
  webinarName: 'Web ',
  webinarLink: 'https://us04web.zoom.us/j/5417077963?pwd=NC9FRFN3VEtXSVNLaTBVb3NhN3BFZz09',
  webinarId: '5417077963',
  webinarPassword: '280729',
  webinarPlatform: 'Zoom',
  calendarLink:
    'https://calendar.google.com/event?action=TEMPLATE&tmeid=MnBjNDk2aWJzY3U2bnM4M2Q2ZjEyb3RvdGUgNDJkZTZyZHF1NDcwMzQ4a3VxNWJoc2p1c29AZw&tmsrc=42de6rdqu470348kuq5bhsjuso%40group.calendar.google.com'
}
